const FETCH_DASHBOARD_REGISTERS = "FETCH_DASHBOARD_REGISTERS";
const FETCH_DASHBOARD_REGISTERS_SUCCESS = "FETCH_DASHBOARD_REGISTERS_SUCCESS";
const FETCH_DASHBOARD_REGISTERS_ERROR = "FETCH_DASHBOARD_REGISTERS_ERROR";

export {
  FETCH_DASHBOARD_REGISTERS,
  FETCH_DASHBOARD_REGISTERS_SUCCESS,
  FETCH_DASHBOARD_REGISTERS_ERROR,
};
